import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const PersonTileWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: start;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  position: relative;

  &:hover {
    > .person_image {
      opacity: 1;
    }
    > .person_image__overlay {
      opacity: 0;
    }
  }
`;

export const Image = styled(motion.img)<{ overlay?: boolean }>`
  width: 100%;
  aspect-ratio: 1/1;
  pointer-events: none;

  position: ${({ overlay }) => (overlay ? 'relative' : 'absolute')};
  inset: 0;

  transition: opacity 0.5s;

  ${({ overlay }) =>
    !overlay &&
    css`
      opacity: 0;
    `}
`;
